import React, {useState, useEffect, useMemo} from "react";
import { useSelector, useDispatch } from "react-redux";
import { Formik, Form } from "formik";
import moment from "moment";
import Carousel from "react-bootstrap/Carousel"
import { ownerBranchs } from "../../redux/actions/branchs";
import api from "../../service/api";
// COMPONENTS
import EstablishmentHeader from "../../components/EstablishmentHeader";
import EstablishmentGrafic from "../../components/EstablishmentGraficBar";
import EstablishmentBox from "../../components/EstablishmentBox";
import EstablishmentInfo from "../../components/EstablishmentInfo";
import Graphic from "../../components/Graphic";
import Table from "../../components/Table";
import ModalDetails from "../../components/ModalDetails";
import ModalDetailsFuture from "../../components/ModalDetailsFuture";
import ModalTransfers from "../../components/ModalTransfers";
import ModalActions from "../../components/ModalActions";
import ModalSuccess from "../../components/ModalSuccessMessage";
import CreditCard from "../../components/CreditCard";
import Button from "../../components/Button";
import Animation from "../../components/Animation/animation";
import { 
  Container, 
  MainColumn, 
  SideColumn, 
  EstablimentBoxAndGraficContainer,
  EstablishmentInfoMainContainer,
  EstablishmentInfoContainer,
  THead, 
  Th, 
  ThFilterable, 
  Td, 
  CircleStatus, 
  DetailsButton,
  NavigationContainer,
  TextContainer,
  InfoContainer,
  Row,
  FirstColumn,
  SecondColumn,
  ThirdColumn,
  Title,
  Info,
  TitleField,
  ColumnPrimaryData,
  ColumnAddress,
  ColumnAddressNumber,
  ShowDetails,
  AddEstablishmentHeader,
  AddEstablishmentHeaderPage,
  RowForButton,
  ButtonContainer,
  ErrorMessage,
  HeaderModalDialog,
  BodyModalDialog,
  FooterModalDialog,
  ModalContinue
} from "./styles";

//Assets
import colors from "../../assets/css/colors";
import payOrder from "../../assets/icons/pay-orderHover.svg";
import creditCardIcon from "../../assets/icons/credit-card-hover.svg";
import upArrow from "../../assets/icons/chevron-up.svg";
import downArrow from "../../assets/icons/chevron-down.svg";
import coins from "../../assets/icons/money-big.svg";
import cart from "../../assets/icons/supermarket.svg";
import money from "../../assets/icons/dollar.svg";
import team from "../../assets/icons/team-big.svg";
import pixIcon from "../../assets/icons/pixIconHover.svg"
//Help Functions
import { openModal, closeModal } from "../../helpers/modalFunctions";
//Data
import { clientDashBoard } from "../../data/provisionalData";
//Interface
import { CircleColorDefiner, ICategory, ICategoryMerchant, TCircleColorDefiner } from "./interfaces"
//Utils
import { translateStatus } from "../../utils/translate/status";
import { translatePaymentType } from "../../utils/translate/paymentType";
import { toastCreate, toastUpdate } from "../../utils/notifications/toast";
import { Modal } from "react-bootstrap";
import StepOne from "../../components/AddEstablishment/StepOne";
import { IDataStepOne } from "../../components/AddEstablishment/StepOne/interface";
import StepTwo from "../../components/AddEstablishment/StepTwo";
import StepThree from "../../components/AddEstablishment/StepThree";
import StepFour from "../../components/AddEstablishment/StepFour";
import { CepDetailInterface } from "../../service/interfaces/cepDetail";
import { cepObject } from "../../service/cepDetail";
import color from "../../assets/css/colors";

const Dashboard = () => {
  const login = useSelector((state: {login: any}) => state.login);
  const owner = useSelector((state: {branchs: any}) => state.branchs);
  const [show, setShow] = useState("1");
  const [ fantasyName, setFantasyName ] = useState("")
  const [ documentStorage, setDocumentStorage ] = useState("")
  const handleClose = () => {
    setShow("1");
    setAddPageNumber(0)
    localStorage.removeItem("addEstablishment");
  }
  const dispatch = useDispatch();
  const [continueForm, setContinueForm] = useState({
    step: 0,
    clientType: 2,
    fantasyName: "",
    sellerOwnerPayId: "",
    doc: ""
  });

  const [branchs, setBranchs] = useState<Array<any>>([
    {
      ownersId: login.user.ownersId,
      businessName: `${login.user.owners.businessName} - Matriz`,
    }
  ]);

  const [recurrence, setRecurrence] = useState({
    id: "",
    name: "",
    planIdAdquirente: "",
    amount: "",
    description: "",
    frequency: "",
    duration: 0
  });
  const [debouncedRecurrenceName, setDebouncedRecurrenceName] = useState("");
  const [recurrenceSearchDataResults, setRecurrenceSearchDataResults] = useState<Array<any>>([]);

  const [tableNavigation, setTableNavigation] = useState(0);
  const [showCardDetails, setShowCardDetails] = useState(false);
  const [clientType, setClientType] = useState(2);
  
  const [addPageNumber, setAddPageNumber] = useState(0);
  const [addMessageError, setAddMessageError] = useState(false);

  const [messageError, setMessageError] = useState("")
  const [dataBanks, setDataBanks] = useState<Array<any>>([
    {
      value: "",
      label: ""
    }
  ]);
  const [selectedBank, setSelectedBank] = useState("")
  const [addModalIsOpen, setAddModalIsOpen] = useState(false)
  const [isSameAddress, setIsSameAddress] = useState(false)

  const [selectedBranch, setSelectedBranch] = useState(branchs[0]);

  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);

  const [filterGraficButton, setFilterGraficButton] = useState(2);

  const [typeGraphic, setTypeGraphic] = useState("line")

  const [transactionsData, setTransactionsData] = useState<Array<any>>([]);
  const [transactionSelected, setTransactionSelected] = useState<object>({});

  const [subscriptionsData, setSubscriptionsData] = useState<Array<any>>([]);
  const [selectedSubscription, setSelectedSubscription] = useState<any>({
    recurrenceBranch: {
      businessDescription: ""
    }
  });
  const [cardData, setCardData] = useState([{
    first4Digits: "",
    last4Digits:"",
    holderName:"",
    cvv:"",
    expirationMonth:"",
    expirationYear: ""
  }]);

  const [transferData, setTransferData] = useState<Array<any>>([]);
  const [transferPage, setTransferPage] = useState(1)
  const [transferMaxPage, setTransferMaxPage] = useState(1)
  const [isLoading, setIsLoading] = useState(false);
  const [companyId, setCompanyId] = useState("");

  const [selectedTransferData, setSelectedTransferData] = useState<any>({
    amount: "",
    type: "",
    bank_account: {
      holder_name: "",
      taxpayer_id: "",
      bank_name: "",
      account_number: "",
      routing_number: "",
    },
    transfer_date: ""
  });

  const [monetaryInfo, setMonetaryInfo] = useState<any>({
    "ticketMed": 0,
    account_balance: 0,
    "boletos": [
        {
            "Boletos": [
                {
                    "sum": "0"
                }
            ],
            "boletosAprov": {
                "boletosAprov": [
                    {
                        "sum": "0"
                    }
                ],
                "percBolAprov": 0
            },
            "boletosFail": {
                "boletosFail": [
                    {
                        "sum": "0"
                    }
                ],
                "percBolFail": 0
            }
        }
    ],
    "cards": [
        {
            "Cards": [
                {
                    "sum": "0"
                }
            ],
            "cardAprov": {
                "cardsAprov": [
                    {
                        "sum": "0"
                    }
                ],
                "percCardAprov": 0
            },
            "cardFail": {
                "cardsFail": [
                    {
                        "sum": "0"
                    }
                ],
                "percCardFail": 0
            },
            "pixAprov": {
              "pixsAprov": [
                {
                  "sum": "0"
                }
              ],
              "percPixAprov": 0
            }
        }
    ],
    "acountsales": [
        {
            "acount": "0"
        }
    ],
    "acountBuyers": [
        {
            "acount": "0"
        }
    ]
  });

  const [pageSubscription, setPageSubscription] = useState(1);
  const [maxPageSubscription, setMaxPageSubscription] = useState(1);

  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);

  const date = new Date();

  const [optionsCategories, setOptionsCategories] = useState<Array<ICategoryMerchant>>([]);

  const [dataStepOne, setDataStepOne] = useState<IDataStepOne>({
    postalCode: "",
    city: "",
    uf: "",
    address: "",
    neighborhood: "",
    addressNumber: "",
    complement: "",
    description: "",
    email: "",
    mmc: "",
    primaryColor: "",
    secundaryColor: "",
    businessWebSite: "",
    businessFacebook: "",
    businessInstagram: "",
    businessTwitter: "",
    ein: "",
    name: "",
    businessPhone: "",
    businessOpeningDate: "",
    businessName: "",
    businessCategory: "",
    firstName: "",
    lastName: ""
  })

  const [dataStepThree, setDataStepThree] = useState(
    {
      step: addPageNumber,
      sellerOwnerPayId: companyId,
      fantasyName: fantasyName,
      clientType: clientType,
      doc: documentStorage
    }
  )

  useEffect(() => {
    const getBranchsForThisOwner = async () => {
      if(owner.branchs.length === 0){
        const {data} = await api.get("/adm/owner100pay/list", {
          params: {
            id: login.user.owners.id
          }
        });
        const branchsFoundeds = [...data.Branch];
        
        setBranchs([...branchs, ...branchsFoundeds]);
        dispatch(ownerBranchs(branchsFoundeds));
      } 
      
      else if(branchs.length === 1){
        setBranchs([...branchs, ...owner.branchs]);
      }
    }

    getBranchsForThisOwner();    
  }, [owner.branchs]);

  useEffect(() => {
    const timerId = setTimeout(() => {
        setDebouncedRecurrenceName(recurrence.name);
    }, 300);
    
    return () => {
        clearTimeout(timerId);
    }
  }, [recurrence.name]);

  useEffect(() => {
    const getData = () => {
      setContinueForm(JSON.parse(localStorage.getItem("addEstablishment") as string))
    }
    
    if(show === "0"){
      getData();
    }
  }, [show])

  useEffect(() => {
      const getRecurrencePlansAtApi = async () => {
          const {data} = await api.get("/adm/ownerbranch/list?id=${login.user.branchsId}&filter=${debouncedRecurrenceName}");
          
          setRecurrenceSearchDataResults(data.Recurrence)
      }
      
      if(debouncedRecurrenceName !== ""){
        getRecurrencePlansAtApi();
      }
  }, [debouncedRecurrenceName]);

  useEffect(() => {
    const getCategories = async () => {
      const {data} = await api.get("/adm/ownerbranch/mmc/list");
      
      setOptionsCategories(data);
    };

    if(addModalIsOpen){
      getCategories()
    }
  }, [addModalIsOpen])

  useEffect(()=>{
    const getBanks = async () => {
      const {data} = await api.get("banks/list")
      
      setDataBanks(data)
    }
    
    if(addModalIsOpen) {
      getBanks();
    }
  }, [addModalIsOpen])

  useEffect(() => {
    const getDashboardCardsInfo = async () => {
      if(selectedBranch.ownersId === undefined){
        const response = await api.get("/branch/balance", {
          params: {
            sellerOwnerPayId: selectedBranch.sellerOwnerPayId,
            apiOwnerId: "ZOOP"
          }
        });
        const responseDashboardCards = await api.get("/dashboard/branch/cards", {
          params: {
            sellerOwnerPayId: selectedBranch.sellerOwnerPayId
          }
        });
        const newMonetaryInfoObject = {
          ...responseDashboardCards.data,
          account_balance: response.data.name === "Error" ? "0,00" : response.data.items.account_balance
        };
        
        setMonetaryInfo(newMonetaryInfoObject);
      }
      
      else {
        const { data } = await api.get("/dashboard/owner/cards", {
          params: {
            id: login.user.ownersId
          }
        });
  
        setMonetaryInfo({
          ...data,
          account_balance: 0
        });
      }
    }

    getDashboardCardsInfo();
  }, [selectedBranch]);

  useEffect(() => {
    const getTrasferDataAtApi = async () => {
      if(selectedBranch.id !== undefined){

      }
      
      else {
        const {data} = await api.post("/adm/owner100pay/transfers/?page=${transferPage}");
        
        setTransferMaxPage(data.pageCount)
        setTransferData(data.branchTransfer);
      }
    }

    const getSubscriptionsData = async () => {
      if(selectedBranch.id !== undefined){
        try {
          const {data} = await api.get("/subscription/list?page=${pageSubscription}&id=${selectedBranch.id}");
          
          setSubscriptionsData(data.Subscriptions);
          setMaxPageSubscription(data.pageCount);
        } catch (error) {}
      }
      
      else {
        try {
          const { data } = await api.get("subscription/list?", {
            params: {
              owner100PayId: selectedBranch.ownersId,
              page: pageSubscription
            }
          });
          
          setSubscriptionsData(data.Subscription);
          setMaxPageSubscription(data.pageCount);
        } catch (error) {
          
        }
      }
    }
    
    switch(tableNavigation){
      case 1:
        getTrasferDataAtApi();
      
        return;
      
      case 3:
        getSubscriptionsData();
      
        return;
      
      default: return;
    }
  }, [tableNavigation, selectedBranch, pageSubscription, transferPage ])

  useEffect(() => {
    setIsLoading(true)
    const getTransactionsAtApi = async () => {
      if(selectedBranch.id !== undefined){
        
        let data = [];
        
        if(filterGraficButton === 2){
          
          const response = await api.get("/transaction/list", {
            params: {
              page: page,
              bid: selectedBranch.sellerOwnerPayId,
              apiOwnerId: "ZOOP",
              week: true
            }
          });
          
          data = response.data;
        }
        
        if(filterGraficButton === 1){
          
          const response = await api.get("/transaction/list", {
            params: {
              page: page,
              bid: selectedBranch.sellerOwnerPayId,
              apiOwnerId: "ZOOP",
              month: moment().month() + 1
            }
          });
  
          data = response.data;
        }
        
        if(filterGraficButton === 0 && startDate !== null && endDate !== null){
          
          const response = await api.get("/transaction/list", {
            params: {
              page: page,
              bid: selectedBranch.sellerOwnerPayId,
              apiOwnerId: "ZOOP",
              fdate: moment(startDate).format("YYYY-MM-DD"),
              ldate: moment(endDate).format("YYYY-MM-DD")
            }
          });
  
          data = response.data;
        }
    
        if(data.Transactions !== undefined){
          setTransactionsData(data.Transactions);
          setMaxPage(data.pageCount);
          setIsLoading(false)
        }
      } else {
        let data = [];
        
        if(filterGraficButton === 2){
          const response = await api.get("/transaction/owner/list", {
            params: {
              page: page,
              bid: selectedBranch.ownersId,
              apiOwnerId: "ZOOP",
              week: true
            }
          });
          
          data = response.data;
        }
        
        if(filterGraficButton === 1){
          const response = await api.get("/transaction/owner/list", {
            params: {
              page: page,
              bid: selectedBranch.ownersId,
              apiOwnerId: "ZOOP",
              month: moment().month() + 1
            }
          });

          data = response.data;
        }
        
        if(filterGraficButton === 0 && startDate !== null && endDate !== null){
          const response = await api.get("/transaction/owner/list", {
            params: {
              page: page,
              bid: selectedBranch.ownersId,
              apiOwnerId: "ZOOP",
              fdate: moment(startDate).format("YYYY-MM-DD"),
              ldate: moment(endDate).format("YYYY-MM-DD")
            }
          });

          data = response.data;
        }
    
        if(data.Transactions !== undefined){
          setTransactionsData(data.Transactions);
          setMaxPage(data.pageCount);
          setIsLoading(false)
        }
      }
    }
    
    if(page !== 0){
      getTransactionsAtApi();
    }
  }, [page, filterGraficButton, selectedBranch, startDate, endDate]);

  useEffect(() => {
    setPage(0);
    setPage(1);
  }, [filterGraficButton]);

  const tableFormaterDefiner = () => {
    if(tableNavigation === 0) {
      return(
        <Table
          filter={true}
          page={page}
          maximumPage={maxPage}
          setPage={setPage}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          filterGraficButton={filterGraficButton}
          setFilterGraficButton={setFilterGraficButton}
        >
          <THead>
              <tr>
                <Th>Valor</Th>
                <Th>Taxa</Th>
                <Th>Valor Líquido</Th>
                <ThFilterable>
                  <div>Status</div>
                  <div style={{ marginLeft: 3, lineHeight: 0.7 }}>
                    <img src={upArrow} alt="seta para cima" />
                    <br />
                    <img src={downArrow} alt="seta para baixo" />
                  </div>
                </ThFilterable>
                <Th>Estabelecimento</Th>
                <Th>Data da venda</Th>
                <Th>Data do pagamento</Th>
                <Th>MÉTODO DE PAGAMENTO</Th>
                <Th></Th>
              </tr>
            </THead>
            {
              isLoading 
              ? <Animation/>
              : <tbody>
                  { tableSellsListContentGenerator() }
              </tbody>
            }
        </Table>
      )
    }
    
    if(tableNavigation === 1){
      return(
        <Table
          page={transferPage}
          maximumPage={transferMaxPage}
          setPage={setTransferPage}
          nonFilterable={true}
          showExportButton={login.user.groups.am1e}
        >
          <THead>
              <tr>
                <Th>Valor</Th>
                <ThFilterable>
                  <div>Status</div>
                  <div style={{ marginLeft: 3, lineHeight: 0.7 }}>
                    <img src={upArrow} alt="seta para cima" />
                    <br />
                    <img src={downArrow} alt="seta para baixo" />
                  </div>
                </ThFilterable>
                <Th>Nome</Th>
                <Th>Cpf/Cnpj</Th>
                <Th>Data da transferência</Th>
                <Th></Th>
              </tr>
            </THead>
            <tbody>{tableTransferContentGenerator()}</tbody>
        </Table>
      )
    }
    
    if(tableNavigation === 2){
      return(
        <Table 
          page={page}
          maximumPage={maxPage}
          setPage={setPage}
        >
          <THead>
              <tr>
                <Th>Valor Bruto</Th>
                <Th>Taxa</Th>
                <Th>Valor Líquido</Th>
                <Th>Data da venda</Th>
                <Th>Pagamento Previsto</Th>
                <Th></Th>
              </tr>
            </THead>
            <tbody>{tableFutureContentGenerator()}</tbody>
        </Table>
      )
    }
    
    if(tableNavigation === 3){
      return(
        <Table
          page={pageSubscription}
          maximumPage={maxPageSubscription}
          setPage={setPageSubscription}
          nonFilterable={true}
          showExportButton={login.user.groups.am1e}
        >
          <THead>
              <tr>
                <Th>ID</Th>
                <ThFilterable>
                  <div>Status</div>
                  <div style={{ marginLeft: 3, lineHeight: 0.7 }}>
                    <img src={upArrow} alt="seta para cima" />
                    <br />
                    <img src={downArrow} alt="seta para baixo" />
                  </div>
                </ThFilterable>
                <Th>Nome</Th>
                <Th>CPF</Th>
                <Th>Nome do plano</Th>
                <Th></Th>
              </tr>
            </THead>
            <tbody>{tableSubscriptionsContentGenerator()}</tbody>
        </Table>
      )
    }
  }

  const tableSellsListContentGenerator = () => {
    return transactionsData.map((transaction) => {
      let date = moment(transaction.tr_created_at).add(3 ,"hours").format("DD/MM/YYYY").toLocaleString(); //corringindo UTC Timezone
      let dateUpdate = moment(transaction.tr_updated_at).add(3 ,"hours").format("DD/MM/YYYY").toLocaleString();
      
      return(
        <tr key={`table_${transaction.tr_id}`} style={{ height: 67 }}>
          <Td><span>R${parseFloat(transaction.tr_amount).toLocaleString("pt-br", {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span></Td>
          <Td><span>R${parseFloat(transaction.tr_fees).toLocaleString("pt-br", {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span></Td>
          <Td><span>R${(parseFloat(transaction.tr_amount) - parseFloat(transaction.tr_fees)).toLocaleString("pt-br", {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span></Td>
          <Td>
            <div className="d-flex align-items-start justify-content-start">
              <CircleStatus color={circleColorDefiner(transaction.tr_status)}/>
              {translateStatus(transaction.tr_status)}
            </div>
          </Td>
          <Td>{transaction.tr_statementDescriptor === "CURSOS AVANAR" ? "CURSOS AVANÇAR" : transaction.tr_statementDescriptor}</Td>
          
          <Td>{date}</Td>
          <Td>{dateUpdate}</Td>
          <Td>{translatePaymentType(transaction.tr_paymentType)}</Td>
          <Td style={{paddingTop: 9}}>{isDetailsButtonShowed(transaction)}</Td>
        </tr>
      )
    });
  }

  const isDetailsButtonShowed = (transaction: any) => {
    if(login.user.groups.cm1r2){ 
      return <DetailsButton onClick={() => handleDetailButtonClick(transaction)}><span style={{height: 8}}>Ver detalhes</span></DetailsButton>
    } else {
      return null
    }
  }

  const handleDetailButtonClick = async (transaction: any) => {
    try {
      const response = await api.get("/transaction/list", {
        params: {
          transactionNumber: transaction.tr_transactionNumber,
          apiOwnerId: "ZOOP"
        }
      });
      const newData: object = response.data.TransactionsDetails;
      const transacionCompleteData = {...transaction, ...newData, ...response.data.buyer[0]};
      
      setTransactionSelected(transacionCompleteData);
      openModal("details");
    } catch (error) {

    }
  }

  const tableTransferContentGenerator = () => {
    return transferData.map((transfer) => (
      <tr key={transfer.id} style={{ height: 67 }}>
        <Td><span>R${parseFloat(transfer.amount).toLocaleString("pt-br", {maximumFractionDigits: 2, minimumFractionDigits: 2})}</span></Td>
        <Td>
          <div className="d-flex align-items-start justify-content-start">
            <CircleStatus color={circleColorDefiner(transfer.status)}/>
            {translateStatus(transfer.status)}
          </div>
        </Td>
        <Td>{`${transfer.bank_account.holder_name}`}</Td>
        <Td>{transfer.bank_account.taxpayer_id}</Td>
        <Td>{moment(transfer.transfer_date).add(3, "hours").format("DD/MM/YYYY")}</Td>
        <Td style={{paddingTop: 9}}><DetailsButton onClick={() => handleClickTransferDetail(transfer)}><span style={{height: 8}}>Ver detalhes</span></DetailsButton></Td>
      </tr>
    ));
  }

  const handleClickTransferDetail = (transfer: any) => {
    setSelectedTransferData(transfer);
    openModal("transfers");
  }

  const tableFutureContentGenerator = () => {
    return clientDashBoard.map((user) => (
      <tr key={user.id} style={{ height: 67 }}>
        <Td><span>R${user.value.toFixed(2).replace(".", ",")}</span></Td>
        <Td><span>R${user.tax.toFixed(2).replace(".", ",")}</span></Td>
        <Td><span>R${(user.value - user.tax).toFixed(2).replace(".", ",")}</span></Td>
        <Td>{user.dueDate}</Td>
        <Td>{user.dueDate}</Td>
        <Td style={{paddingTop: 9}}><DetailsButton data-toggle="modal" data-target="#details-future"><span style={{height: 8}}>Ver detalhes</span></DetailsButton></Td>
      </tr>
    ));
  }

  const tableSubscriptionsContentGenerator = () => {
    return subscriptionsData.map((subscription) => (
      <tr key={subscription.sb_id} style={{ height: 67 }}>
        <Td>{subscription.sb_id}</Td>
        <Td>{subscription.sb_status === "active" ? "Ativo" : "Inativo"}</Td>
        <Td>{`${subscription.bu_firstName} ${subscription.bu_lastName}`}</Td>
        <Td>{subscription.bu_taxpayerId}</Td>
        <Td>{subscription.sb_name}</Td>
        <Td style={{paddingTop: 9}}><DetailsButton onClick={() => handleClickDetailSubscription(subscription)}><span style={{height: 8}}>Ver detalhes</span></DetailsButton></Td>
      </tr>
    ));
  }

  const handleClickDetailSubscription = async (subscription: any) => {
    try {
      const {data} = await api.get("/card/list", {
          params: {
              cardBuyerId: subscription.bu_id
          }
      });
      const response = await api.get("buyer/list", {
        params: {
          id: subscription.bu_id
        }
      });
      const responseRecurrenceDetail = await api.get("recurrence/list", {
        params: {
          id: subscription.sb_planRecurrenceId
        } 
      });
      
      setCardData(data.CardBuyer);
      setSelectedSubscription({...subscription, ...response.data.buyers[0].Buyer[0], ...responseRecurrenceDetail.data.users[0]});
      
      openModal("subscriptions");
    } catch (error) {
      
    }
  }

  const generateSubscriptionCard = () => {
    return cardData.map((card, index) => {
      return (
        <div key={`card_${index}`}>
          <div className="d-flex justify-content mb-2">
            <Info>Cartão 1</Info>
            <ShowDetails onClick={() => setShowCardDetails(!showCardDetails)}><div>Ver Detalhes</div></ShowDetails>
          </div>
          {showCardDetails ? 
            <CreditCard 
              id={1} 
              firstNumbers={card.first4Digits}
              lastNumbers={card.last4Digits}
              name={card.holderName}
              cvv=""
              valid={`${card.expirationMonth}/${card.expirationYear}`}
            /> : null}
        </div>
      )
    });
  }

  const circleColorDefiner = (status: TCircleColorDefiner) => {
    return CircleColorDefiner[status as keyof typeof CircleColorDefiner] ?? color.gray
  }

  return(
    <div>
      <ModalTransfers id="transfers" data={selectedTransferData}/>
      <ModalDetails id="details" data={transactionSelected} selectedBranch={selectedBranch}/>
      <ModalDetailsFuture/>
      <ModalSuccess text="Cadastro finalizado!"/>
      <ModalActions id="subscriptions" title="Informações da assinatura">
        <InfoContainer>
          <Row>
            <FirstColumn>
              <Title>Vendedor</Title>
              <Info>{selectedSubscription.recurrenceBranch.businessDescription}</Info>
            </FirstColumn>
            <SecondColumn>
              <Title>Nome do Plano</Title>
              <Info>{selectedSubscription.name}</Info>
            </SecondColumn>
            <ThirdColumn>
              <Title>Status</Title>
              <Info>{selectedSubscription.isActive ? "Ativo" : "Inativo"}</Info>
            </ThirdColumn>
          </Row>

          <Row>
            <FirstColumn>
              <Title>Métodos de Pagamento</Title>
              <Info>{selectedSubscription.paymentMethods}</Info>
            </FirstColumn>
            <SecondColumn>
              <Title>Descrição</Title>
              <Info>{selectedSubscription.description}</Info>
            </SecondColumn>
          </Row>

          <Row>
            <FirstColumn>
              <Title>Data de criação</Title>
              <Info>{moment(selectedSubscription.datahora_cad).format("DD/MM/YYYY")}</Info>
            </FirstColumn>
            <SecondColumn>
              <Title>Frequência</Title>
              <Info>{selectedSubscription.frequency}</Info>
            </SecondColumn>
            <ThirdColumn>
              <Title>Intervalo</Title>
              <Info>{selectedSubscription.interval}</Info>
            </ThirdColumn>
          </Row>

          <Row>
            <FirstColumn>
              <Title>Período de Carência</Title>
              <Info>{selectedSubscription.gracePeriod}</Info>
            </FirstColumn>
            <SecondColumn>
              <Title>Tolerância na Falha</Title>
              <Info>{selectedSubscription.tolerancePeriod}</Info>
            </SecondColumn>
            <ThirdColumn>
              <Title>Duração do Plano</Title>
              <Info>{selectedSubscription.duration}</Info>
            </ThirdColumn>
          </Row>

          <Row>
            <FirstColumn>
              <Title>Valor do Plano</Title>
              <Info>R$ {(parseInt(selectedSubscription.amount) / 100).toLocaleString("pt-br", {maximumFractionDigits: 2, minimumFractionDigits: 2}) }</Info>
            </FirstColumn>
            <SecondColumn>
              <Title>Valor do Setup</Title>
              <Info>R$ {(parseInt(selectedSubscription.setupAmount) / 100).toLocaleString("pt-br", {maximumFractionDigits: 2, minimumFractionDigits: 2})}</Info>
            </SecondColumn>

          </Row>
        </InfoContainer>

        <InfoContainer>
          <TitleField>Dados Principais</TitleField>
          <Row>
            <ColumnPrimaryData>
              <Title>Nome</Title>
              <Info>{`${selectedSubscription.firstName} ${selectedSubscription.lastName}`}</Info>
            </ColumnPrimaryData>
            <ColumnPrimaryData>
              <Title>Email</Title>
              <Info>{selectedSubscription.email}</Info>
            </ColumnPrimaryData>
            <ColumnPrimaryData>
              <Title>Telefone</Title>
              <Info>{selectedSubscription.phoneNumber}</Info>
            </ColumnPrimaryData>
            <div>
              <Title>CPF</Title>
              <Info>{selectedSubscription.taxpayerId}</Info>
            </div>
          </Row>
        </InfoContainer>

        <InfoContainer>
          <TitleField>Endereço</TitleField>
          <Row>
            <ColumnAddress>
              <Title>CEP</Title>
              <Info>{selectedSubscription.addressPostalCode}</Info>
            </ColumnAddress>
            <ColumnAddress>
              <Title>Cidade</Title>
              <Info>{selectedSubscription.addressCity}</Info>
            </ColumnAddress>
            <ColumnAddress>
              <Title>UF</Title>
              <Info>{selectedSubscription.addressState}</Info>
            </ColumnAddress>
            <div>
              <Title>Endereço</Title>
              <Info>{selectedSubscription.addressLine1}</Info>
            </div>
          </Row>
          <Row>
            <ColumnAddressNumber>
              <Title>Número</Title>
              <Info>{selectedSubscription.addressLine2}</Info>
            </ColumnAddressNumber>
            <div>
              <Title>Complemento</Title>
              <Info>{selectedSubscription.addressLine3}</Info>
            </div>
          </Row>
        </InfoContainer>
        <TitleField>Cartão de Cobrança</TitleField>
        { generateSubscriptionCard() }
      </ModalActions>

      <ModalActions id="addEstablishment" title="Adicionar Estabelecimento" subtitle="Adicione um novo estabelecimento a plataforma">
      {
            <ModalContinue
              datatype={show}
            >
              <BodyModalDialog>
              <HeaderModalDialog>
                <Modal.Title>Processo em andamento</Modal.Title>
              </HeaderModalDialog>
                <p>{"Foi detectado um formulário não finalizado."}</p>
                <span>{`Deseja continuar preenchendo os dados da empresa: ${continueForm.fantasyName} ?`}</span>
              </BodyModalDialog>

              <FooterModalDialog>
                <Button id="cancel" onClick={handleClose} >Cancelar</Button>
                <Button id="continue" onClick={() => {
                  setAddPageNumber(continueForm.step)
                  setDataStepThree({
                    clientType: continueForm.clientType,
                    doc: continueForm.doc,
                    fantasyName: continueForm.fantasyName,
                    sellerOwnerPayId: continueForm.sellerOwnerPayId,
                    step: continueForm.step
                  })
                  setShow("1")
                }}>Continuar</Button>
              </FooterModalDialog>
          </ModalContinue>
        }
        <AddEstablishmentHeader >
          <AddEstablishmentHeaderPage data-step="1" isActualOrPrevius={true} onClick={() => setAddPageNumber(0)}>Empresa</AddEstablishmentHeaderPage>
          <AddEstablishmentHeaderPage data-step="2" isActualOrPrevius={addPageNumber >= 1} onClick={() => setAddPageNumber(1)}>Proprietário(a)</AddEstablishmentHeaderPage>
          <AddEstablishmentHeaderPage data-step="3" isActualOrPrevius={addPageNumber >= 2} onClick={() => setAddPageNumber(2)} >Pagamento</AddEstablishmentHeaderPage>
          <AddEstablishmentHeaderPage data-step="4" isActualOrPrevius={addPageNumber >= 3} onClick={() => setAddPageNumber(3)} >Documentos</AddEstablishmentHeaderPage>
        </AddEstablishmentHeader>
        <div className="w-100">
          <Formik
            initialValues={{
            }}
            onSubmit={ async (values, {resetForm}) => {
              toastCreate("submit", "info" , 1000, "Dados processados...");
              
              if (addPageNumber === 3) {
                  closeModal("addEstablishment");
                  localStorage.removeItem("addEstablishment");
                  setAddPageNumber(0);
                  setSelectedBank("");
                  setIsSameAddress(false);
                  setClientType(2)
                  resetForm();
                  setAddModalIsOpen(false);
                  setAddMessageError(false);
                  openModal("exampleModal");
              }
            }}
          >
            {() => {
              return (
                <>
                  {addPageNumber === 0 ? <StepOne data={dataStepOne} setData={setDataStepOne} setClientType={setClientType} step={addPageNumber} setStep={setAddPageNumber}/> : null }
                  {addPageNumber === 1 ? <StepTwo setEstablishmentId={setCompanyId} data={dataStepOne} setData={setDataStepThree} setStep={setAddPageNumber} step={addPageNumber} clientType={clientType}/> : null }
                  {addPageNumber === 2 ? <StepThree data={dataStepThree} setStep={setAddPageNumber} /> : null }
                  {addPageNumber === 3 ? <StepFour data={dataStepThree} /> : null }
                  <Form>
                    <RowForButton>
                      <ButtonContainer>
                        {
                          addMessageError === true && (
                            <div className="d-flex justify-content-start mb-1">
                              <ErrorMessage>
                                { messageError !== "" ? messageError : "Erro ao cadastrar estabelecimento" }
                              </ErrorMessage>
                            </div>
                          )
                        }
                        {
                          addPageNumber === 3
                          ? <Button type="submit"> Concluir </Button>
                          : null
                        }
                        
                      </ButtonContainer>
                    </RowForButton>
                  </Form>
                </>
              )
            }}
          </Formik>
        </div>
      </ModalActions>

      <EstablishmentHeader 
        branchsData={branchs} 
        selectedBranch={selectedBranch}
        setSelectedBranch={setSelectedBranch}
        continueForm={show}
        setContinueForm={setShow}
      />

      <Container>
        <MainColumn>
          {
            window.innerWidth > 500 ? ( //login.user.groups.am1r1
              <EstablimentBoxAndGraficContainer>
                {window.innerWidth > 1200 ? null : <EstablishmentBox 
              selectedBranch={selectedBranch}
              tooltip={false}
            />}
                <EstablishmentGrafic 
                  title="Boleto Aprovados"
                  value={parseFloat(monetaryInfo.boletos[0].boletosAprov.boletosAprov[0].sum)}
                  icon={payOrder}
                  approved={monetaryInfo.boletos[0].boletosAprov.percBolAprov}
                  approvedSum={parseFloat(monetaryInfo.boletos[0].boletosAprov.boletosAprov[0].sum)}
                  pendent={0}
                  canceled={monetaryInfo.boletos[0].boletosFail.percBolFail}
                  canceledSum={parseFloat(monetaryInfo.boletos[0].boletosFail.boletosFail[0].sum)}
                />
                <EstablishmentGrafic 
                  title="Crédito Aprovado"
                  value={parseFloat(monetaryInfo.cards[0].cardAprov.cardsAprov[0].sum)}
                  icon={creditCardIcon}
                  approved={monetaryInfo.cards[0].cardAprov.percCardAprov}
                  approvedSum={parseFloat(monetaryInfo.cards[0].cardAprov.cardsAprov[0].sum)}
                  pendent={0}
                  canceled={monetaryInfo.cards[0].cardFail.percCardFail}
                  canceledSum={parseFloat(monetaryInfo.cards[0].cardFail.cardsFail[0].sum)}
                />
                <EstablishmentGrafic 
                  title="Pix Aprovado"
                  value={parseFloat(monetaryInfo.cards[0].pixAprov?.pixsAprov[0].sum)}
                  icon={pixIcon}
                  approved={monetaryInfo.cards[0].pixAprov?.percPixAprov}
                  approvedSum={parseFloat(monetaryInfo.cards[0].pixAprov?.pixsAprov[0].sum)}
                  pendent={0}
                  canceled={0}
                  canceledSum={0}
                />
              </EstablimentBoxAndGraficContainer>
            ) : <EstablimentBoxAndGraficContainer> 
            <EstablishmentBox 
                  selectedBranch={selectedBranch}
                />
                <Carousel controls={false} interval={null} >
              <Carousel.Item>
              <EstablishmentGrafic 
                  title="Boleto Aprovados"
                  value={parseFloat(monetaryInfo.boletos[0].boletosAprov.boletosAprov[0].sum)}
                  icon={payOrder}
                  approved={monetaryInfo.boletos[0].boletosAprov.percBolAprov}
                  approvedSum={parseFloat(monetaryInfo.boletos[0].boletosAprov.boletosAprov[0].sum)}
                  pendent={0}
                  canceled={monetaryInfo.boletos[0].boletosFail.percBolFail}
                  canceledSum={parseFloat(monetaryInfo.boletos[0].boletosFail.boletosFail[0].sum)}
                />
              </Carousel.Item>
              <Carousel.Item>
              <EstablishmentGrafic 
                  title="Crédito Aprovado"
                  value={parseFloat(monetaryInfo.cards[0].cardAprov.cardsAprov[0].sum)}
                  icon={creditCardIcon}
                  approved={monetaryInfo.cards[0].cardAprov.percCardAprov}
                  approvedSum={parseFloat(monetaryInfo.cards[0].cardAprov.cardsAprov[0].sum)}
                  pendent={0}
                  canceled={monetaryInfo.cards[0].cardFail.percCardFail}
                  canceledSum={parseFloat(monetaryInfo.cards[0].cardFail.cardsFail[0].sum)}
                />
              </Carousel.Item>
              < Carousel.Item>
                <EstablishmentGrafic 
                  title="Pix Aprovado"
                  value={parseFloat(monetaryInfo.cards[0].pixAprov?.pixsAprov[0].sum)}
                  icon={pixIcon}
                  approved={monetaryInfo.cards[0].pixAprov?.percPixAprov}
                  approvedSum={parseFloat(monetaryInfo.cards[0].pixAprov?.pixsAprov[0].sum)}
                  pendent={0}
                  canceled={0}
                  canceledSum={0}
                />
              </Carousel.Item>
            </Carousel>
            </EstablimentBoxAndGraficContainer>
          }

          {
            true ? ( //login.user.groups.am1r2

              <EstablishmentInfoMainContainer>
                <EstablishmentInfoContainer>     
                  <EstablishmentInfo
                    value={monetaryInfo.ticketMed}
                    title="TICKET MÉDIO MÊS"
                    ps="*Valor médio das transações aprovadas no mês."
                    money={true}
                    img={coins}
                    date={date.toLocaleString()}
                  />

                  <EstablishmentInfo
                    value={Object.keys(monetaryInfo).length !== 0 ? monetaryInfo.acountsales[0].acount : null}
                    title="Nº DE VENDAS DIA"
                    img={cart}
                    ps="*Quantidade de vendas aprovadas no dia."
                    date={date.toLocaleString()}
                  />
                
                  <EstablishmentInfo
                    value={Object.keys(monetaryInfo).length !== 0 ? monetaryInfo.acountBuyers[0].acount : null}
                    titleDown="Nº DE CLIENTES"
                    img={team}
                  />
                </EstablishmentInfoContainer>
              </EstablishmentInfoMainContainer>
            ) : null
          }

          {
            true ? ( //login.user.groups.am1r3
              <Graphic 
                sellerOwnerPayId={selectedBranch.sellerOwnerPayId === undefined ? selectedBranch.ownersId : selectedBranch.sellerOwnerPayId} 
                isOwner={selectedBranch.sellerOwnerPayId === undefined ? true : false}
                type={typeGraphic}
                setType={setTypeGraphic}
              />
            ) : null
          }

          {true ? ( //login.user.groups.am1r4
            <>
              <NavigationContainer className="nav nav-tabs">
                <a 
                  className={`nav-link ${tableNavigation === 0 ? "active" : ""}`}
                  onClick={() => setTableNavigation(0)}
                >
                  <li className="nav-item">
                    <TextContainer>
                      <span>LISTA DE VENDAS</span>
                    </TextContainer>
                  </li>
                </a>

                <a 
                  className={`nav-link ${tableNavigation === 1 ? "active" : ""}`}
                  onClick={() => setTableNavigation(1)}
                >
                  <li className="nav-item">
                    <TextContainer>
                      <span>TRANSFERÊNCIAS</span>
                    </TextContainer>
                  </li>
                </a>

                <a 
                  className={`nav-link ${tableNavigation === 3 ? "active" : ""}`}
                  onClick={() => setTableNavigation(3)}
                >
                  <li className="nav-item">
                    <TextContainer>
                      <span>ASSINATURAS</span>
                    </TextContainer>
                  </li>
                </a>
              </NavigationContainer>
              {tableFormaterDefiner()}
            </> ) : null
          }

        </MainColumn>

        <SideColumn>
          {
            true ? ( //login.user.groups.am1r2

              <EstablishmentInfoContainer>
                { selectedBranch.ownersId === undefined && 
                  <EstablishmentInfo
                    value={Number(typeof monetaryInfo.account_balance === "string" ? parseInt(monetaryInfo.account_balance) : monetaryInfo.account_balance) / 100}
                    titleDown="Total a receber"
                    ps="*Valor referente ao mês atual."
                    money={true}
                    img={money}
                  />
                }
              
                <EstablishmentInfo
                  value={monetaryInfo.ticketMed}
                  title="TICKET MÉDIO MÊS"
                  ps="*Valor médio das transações aprovadas no mês."
                  money={true}
                  img={coins}
                  date={date.toLocaleString()}
                />
              
                <EstablishmentInfo
                  value={Object.keys(monetaryInfo).length !== 0 ? parseInt(monetaryInfo.acountsales[0].acount) : 0}
                  title="Nº DE VENDAS DIA"
                  img={cart}
                  ps="*Quantidade de vendas aprovadas no dia."
                  date={date.toLocaleString()}
                />
              
                <EstablishmentInfo
                  value={Object.keys(monetaryInfo).length !== 0 ? parseInt(monetaryInfo.acountBuyers[0].acount) : 0}
                  titleDown="Nº DE CLIENTES"
                  img={team}
                />
              </EstablishmentInfoContainer>
            ) : null
          }
        </SideColumn>
      </Container>
    </div>
  )
}

export default Dashboard;
